import {IProcessFlowStepConstructorOptions} from "~/interfaces/processFlowInterfaces";
import ProcessFlowStep from "~/models/processFlows/processFlowStep";
import ProcessFlowVariable from '~/models/processFlows/processFlowVariable'

export class ProcessFlowCallApiStep extends ProcessFlowStep {
  request_variable_client_id: string
  response_variable_client_id: string
  connection_environment: 'test' | 'live'

  constructor(parent, options: IProcessFlowStepConstructorOptions) {
    super(parent, options);
    this.defineProperty('request_variable_client_id', null, null, null, () => {
      if (this.responseVariable && this.responseVariable.reference_id !== this.requestVariable.reference_id) {
        this.response_variable_client_id = null
      }
    });
    this.defineProperty('response_variable_client_id', null);
    this.defineProperty('connection_environment', null);
  }

  get requestVariable(): ProcessFlowVariable {
    return ProcessFlowVariable.repo.findBy((v) => v.client_id === this.request_variable_client_id)
  }

  get responseVariable(): ProcessFlowVariable {
    return ProcessFlowVariable.repo.findBy((v) => v.client_id === this.response_variable_client_id) || null
  }

  get defaultTitle(): string {
    return `Call an API`
  }
}